const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "masculine",
  "inanimate",
  "feminine",
  "neuter",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle"
] as const

const size = [
  "sm",
  "md",
  "lg"
] as const

export default {
  "base": "inline-flex items-center justify-center px-1 rounded-sm font-medium font-sans uppercase",
  "variants": {
    "color": {
      "primary": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "masculine": "",
      "inanimate": "",
      "feminine": "",
      "neuter": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": ""
    },
    "size": {
      "sm": "h-4 min-w-[16px] text-[10px]",
      "md": "h-5 min-w-[20px] text-[11px]",
      "lg": "h-6 min-w-[24px] text-[12px]"
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-error"
    },
    {
      "color": "masculine" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-masculine"
    },
    {
      "color": "inanimate" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-inanimate"
    },
    {
      "color": "feminine" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-feminine"
    },
    {
      "color": "neuter" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-neuter"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-primary/50 text-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-secondary/50 text-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-success/50 text-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-info/50 text-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-warning/50 text-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-error/50 text-error"
    },
    {
      "color": "masculine" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-masculine/50 text-masculine"
    },
    {
      "color": "inanimate" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-inanimate/50 text-inanimate"
    },
    {
      "color": "feminine" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-feminine/50 text-feminine"
    },
    {
      "color": "neuter" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-neuter/50 text-neuter"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-primary bg-primary/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-secondary bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-success bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-info bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-warning bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-error bg-error/10"
    },
    {
      "color": "masculine" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-masculine bg-masculine/10"
    },
    {
      "color": "inanimate" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-inanimate bg-inanimate/10"
    },
    {
      "color": "feminine" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-feminine bg-feminine/10"
    },
    {
      "color": "neuter" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-neuter bg-neuter/10"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-primary ring ring-inset ring-primary/25 bg-primary/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-secondary ring ring-inset ring-secondary/25 bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-success ring ring-inset ring-success/25 bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-info ring ring-inset ring-info/25 bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-warning ring ring-inset ring-warning/25 bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-error ring ring-inset ring-error/25 bg-error/10"
    },
    {
      "color": "masculine" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-masculine ring ring-inset ring-masculine/25 bg-masculine/10"
    },
    {
      "color": "inanimate" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-inanimate ring ring-inset ring-inanimate/25 bg-inanimate/10"
    },
    {
      "color": "feminine" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-feminine ring ring-inset ring-feminine/25 bg-feminine/10"
    },
    {
      "color": "neuter" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-neuter ring ring-inset ring-neuter/25 bg-neuter/10"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-default"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-default bg-elevated"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-elevated"
    }
  ],
  "defaultVariants": {
    "variant": "outline" as typeof variant[number],
    "color": "neutral" as typeof color[number],
    "size": "md" as typeof size[number]
  }
}